export default __webpack_public_path__ + "a5d290224e71249dea763c58408e097f.png";